var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 36,
    viewBox: "0 0 36 36",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.41405 5.35726c.52466-.46021 1.36044-.44669 1.86675.03021 2.4441 2.30208 5.6016 3.87297 9.0523 4.50361 3.4506.63062 7.0308.29112 10.2639-.97343.6697-.26196 1.4463.01919 1.7345.62796.2882.60879-.0211 1.31459-.6909 1.57659-3.7258 1.4572-7.8515 1.8485-11.828 1.1218-3.9765-.7268-7.6152-2.53706-10.43178-5.18996-.50632-.47689-.49144-1.23656.03323-1.69678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 2.39998c-5.4685 0-9.90155 4.02941-9.90155 8.99992 0 4.9705 4.43305 8.9999 9.90155 8.9999s9.9016-4.0294 9.9016-8.9999c0-4.97051-4.4331-8.99992-9.9016-8.99992zm-12.54196 8.99992c0-6.29599 5.61526-11.3999 12.54196-11.3999s12.542 5.10391 12.542 11.3999c0 6.296-5.6153 11.3999-12.542 11.3999s-12.54196-5.1039-12.54196-11.3999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.42256 26.7876c3.16414-1.8211 6.83224-2.788 10.57744-2.788s7.4133.9669 10.5774 2.788c3.1642 1.8212 5.6942 4.4218 7.2955 7.499.3118.5991.0302 1.3145-.6289 1.5979s-1.4462.0274-1.758-.5717c-1.3874-2.6663-3.5796-4.9196-6.3211-6.4975-2.7416-1.578-5.9199-2.4157-9.1649-2.4157s-6.4233.8377-9.16486 2.4157c-2.74157 1.5779-4.93369 3.8312-6.32119 6.4975-.31176.5991-1.09881.8551-1.757926.5717-.6591173-.2834-.940705-.9988-.628945-1.5979 1.601351-3.0772 4.131341-5.6778 7.295481-7.499z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.023fc66e58dade3c8d231ddd4f78dca7.svg";
export { ForwardRef as ReactComponent };